<p class="play-along-intro">
  Each line includes one or more tempos so you can start slow and build up.
</p>

@for (group of groups; track group.slug) {
  <section
    class="play-along-group"
    [attr.aria-labelledby]="group.slug + '-heading'"
  >
    <h2 [id]="group.slug + '-heading'" class="play-along-group__heading">
      {{ group.title }}
    </h2>
    @if (group.description) {
      <p class="play-along-group__description">{{ group.description }}</p>
    }
    @if (group.notation) {
      <div class="play-along-group__notation">
        <app-lightbox-image
          [src]="'/images/play-along-tracks/' + group.notation.filename"
          [alt]="group.notation.alt"
          caption="Notation"
          [aspectRatio]="group.notation.aspectRatio"
          sizes="(max-width: 600px) 90vw, 60vw"
          [priority]="$first"
        />
      </div>
    }
    <ul class="play-along-tracks">
      @for (track of group.tracks; track track.filename) {
        <li class="play-along-track">
          <span class="play-along-track__tempo">{{ track.tempo }}</span>
          <audio
            controls
            preload="none"
            class="play-along-track__player"
            [src]="'/audio/play-along-tracks/' + track.filename"
            [attr.aria-label]="'Play ' + group.title + ' — ' + track.tempo"
          >
            Your browser does not support the audio element. Direct download:
            <a [href]="'/audio/play-along-tracks/' + track.filename">
              {{ track.filename }}
            </a>
          </audio>
        </li>
      }
    </ul>
  </section>
}
